import { z } from 'zod';
import { booleanQuery, dateSchema, idSchema } from './common.schema.js';
/**
 * Construction-site documents (24.09.2026): protocols, contracts, hand-overs,
 * photos — plus company templates every site pulls from. Deliberately just an
 * ordered folder: no deadlines, no reminders.
 */
/* ───────────────────────────── Categories ──────────────────────────────── */
export const documentCategoryListQuerySchema = z.object({
    includeInactive: booleanQuery(false),
});
/** Umowa/zlecenie, Protokół, Przekazanie… — a dictionary the client edits. */
export const documentCategorySchema = z.object({
    id: idSchema,
    name: z.string(),
    sortOrder: z.number().int(),
    isActive: z.boolean(),
});
export const createDocumentCategorySchema = z.object({
    name: z.string().min(2, 'Podaj nazwę kategorii').max(60),
    /** Left out, the category lands at the end — where a new one belongs. */
    sortOrder: z.number().int().min(1, 'Kolejność zaczyna się od 1').optional(),
});
export const updateDocumentCategorySchema = createDocumentCategorySchema
    .partial()
    .extend({ isActive: z.boolean().optional() });
/* ───────────────────────────── Documents ───────────────────────────────── */
export const projectDocumentSchema = z.object({
    id: idSchema,
    /** `null` = a company template ("wzór firmowy"), visible from every site. */
    projectId: idSchema.nullable(),
    /** Which trading partner on the site the paper concerns, when any. */
    vendorId: idSchema.nullable(),
    vendorName: z.string().nullable(),
    categoryId: idSchema,
    categoryName: z.string(),
    /** Named by hand — file names off a scanner say nothing. */
    name: z.string(),
    originalName: z.string(),
    mimeType: z.string(),
    sizeBytes: z.number().int(),
    uploadedByName: z.string().nullable(),
    uploadedAt: dateSchema,
});
/**
 * The multipart fields that ride along with the file. Everything arrives as
 * strings off the form, so the empty string is normalised away here.
 */
export const createProjectDocumentSchema = z.object({
    name: z.string().trim().min(2, 'Nadaj dokumentowi nazwę').max(120),
    categoryId: idSchema,
    vendorId: z
        .string()
        .nullish()
        .transform((value) => value || null),
});
export const projectDocumentListQuerySchema = z.object({
    categoryId: idSchema.optional(),
    vendorId: idSchema.optional(),
});
//# sourceMappingURL=document.schema.js.map